import { Flex } from 'antd-mobile'
import React, { Component } from 'react'
import cardValidator from 'card-validator'
import _ from 'lodash'
import Cleave from './cleave-react'
import {
  PAYMENT_GATEWAY_FIRST_DATA,
  PAYMENT_GATEWAY_STRIPE,
} from '../../constants/app'
import { encryptToken } from 'helpers/crypto'

class CreditCard extends Component {
  static invalidStyle = {
    color: '#eb1c26',
  }

  constructor (props) {
    super(props)

    this.state = {
      cardValid: false,
      nameValid: false,
      expValid: false,
      cvvValid: false,

      isPaying: false,

      paymentMethod: '',
      cardNumber: '',
      cardholderName: '',
      expMonth: '',
      expYear: '',
      cvm: '',
    }
    window.setTestCard = () => {
      this.setState({
        cardValid: true,
        nameValid: true,
        expValid: true,
        cvvValid: true,

        paymentMethod: 'visa',
        cardNumber: '4035874000424977',
        cardholderName: 'chan',
        expMonth: '12',
        expYear: '24',
        cvm: '977',
      })
    }
  }

  setValid (type, valid) {
    this.setState({ [`${type}Valid`]: valid })
  }

  changeCardType (type) {
    const methodMap = {
      amex: 'ae',
      // diners: 'diners_club',
      mastercard: 'master',
      // jcb: 'jcb',
      visa: 'visa',
      // unionPay: 'unionpay',
    }
    const valid = _.has(methodMap, type)

    this.setValid('card', valid)
    this.setState({ paymentMethod: valid ? methodMap[type] : 'unknown' })
  }

  changeValue (type) {
    return event => {
      let value = event.target.rawValue
      if (type === 'name') {
        value = event.target.value
      }
      let valid
      const date = event.target.value.split('/')
      const expiration = date.join('')
      const exp = {
        month: parseInt(date[0]),
        year: parseInt(date[1]),
      }

      switch (type) {
        case 'card':
          valid = cardValidator.number(value).isValid
          this.setState({ cardNumber: value })
          break
        case 'exp':
          valid = cardValidator.expirationDate(expiration).isValid
          this.setState({ expMonth: exp.month, expYear: exp.year })
          break
        case 'name':
          valid = cardValidator.cardholderName(value).isValid
          this.setState({ cardholderName: value })
          break
        case 'cvv':
          valid = cardValidator.cvv(value).isValid
          this.setState({ cvm: value })
          break
        default:
          break
      }
      this.setValid(type, valid)
    }
  }

  getPrimaryTransactionParams () {
    const { amount } = this.props
    const {
      cardNumber,
      expMonth,
      expYear,
      cvm,
    } = this.state
    const transactionAmount = {
      total: '' + amount / 100,
      currency: 'HKD',
    }
    const paymentMethod = {
      paymentCard: {
        cardholderName: encryptToken(cardNumber),
        number: encryptToken(cardNumber),
        securityCode: encryptToken(cvm),
        expiryDate: {
          month: encryptToken(_.padStart(expMonth, 2, '0')),
          year: encryptToken('' + expYear),
        },
      },
    }

    return {
      requestType: 'PaymentCardPreAuthTransaction',
      transactionAmount,
      paymentMethod,
    }
  }

  async makePayment () {
    const { submit } = this.props
    const { paymentMethod: payment } = this.state

    const payload = this.getPrimaryTransactionParams()

    let gateway = PAYMENT_GATEWAY_FIRST_DATA
    if (payment === 'ae') {
      gateway = PAYMENT_GATEWAY_STRIPE
    }
    this.setState({ isPaying: true })
    await submit({ payment, payload, gateway })
    this.setState({ isPaying: false })
  }

  render () {
    const {
      optionHeading,
      cardPlaceholder,
      formStyle,
    } = this.props
    const {
      cardValid,
      nameValid,
      expValid,
      cvvValid,
      isPaying,
    } = this.state
    const valid = cardValid && nameValid && expValid && cvvValid && !isPaying
    const submitStyle = valid ? formStyle.validStyle : formStyle.invalidStyle

    return (
      <div>
        { optionHeading }
        <div className={ formStyle.paymentOptionStyle } style={ { height: '270px' } }>
          <div>
            <Cleave className={ formStyle.telInputStyle }
              options={ {
                creditCard: true,
                onCreditCardTypeChanged: this.changeCardType.bind(this),
              } }
              onChange={ this.changeValue('card').bind(this) }
              placeholder={ cardPlaceholder.card }
              style={ cardValid !== false ? {} : CreditCard.invalidStyle }/>
          </div>
          <div>
            <input className={ formStyle.telInputStyle }
              onChange={ this.changeValue('name').bind(this) }
              placeholder={ cardPlaceholder.name }
              style={ nameValid !== false ? {} : CreditCard.invalidStyle } />
          </div>
          <div>
            <Flex style={ { overflow: 'visible' } }>
              <Flex.Item>
                <Cleave className={ formStyle.telInputStyle }
                  options={ {
                    date: true,
                    delimiter: ' / ',
                    datePattern: [
                      'm',
                      'y',
                    ],
                  } }
                  onChange={ this.changeValue('exp').bind(this) }
                  placeholder={ cardPlaceholder.exp }
                  style={ expValid !== false ? {} : CreditCard.invalidStyle }/>
              </Flex.Item>
              <Flex.Item>
                <Cleave className={ formStyle.telInputStyle }
                  options={ {
                    blocks: [3],
                    numericOnly: true,
                  } }
                  onChange={ this.changeValue('cvv').bind(this) }
                  placeholder={ cardPlaceholder.cvv }
                  style={ cvvValid !== false ? {} : CreditCard.invalidStyle }/>
              </Flex.Item>
            </Flex>
          </div>

          <div className={ submitStyle }
            onClick={ valid ? () => { this.makePayment() } : null }>
            { cardPlaceholder.pay }
          </div>
        </div>
      </div>
    )
  }
}

export default CreditCard



// WEBPACK FOOTER //
// ./src/components/first-data/CreditCard.js